import axios from 'axios';

import { getLocale } from 'src/packages/utils/get-locale';
import { getAccessToken } from 'src/services/auth-service/auth';
import { UserServiceNS } from 'src/services/auth-service/user-service';

import type { AxiosInstance, CreateAxiosDefaults } from 'axios';

import { API_URL, BASE_URL } from './consts';

const BASE_AXIOS_CONFIG = {
  baseURL: BASE_URL,
  headers: {
    'content-type': 'application/json',
  },
};

const applyBaseInterceprtors = (inst: AxiosInstance) => {
  inst.interceptors.request.use((config) => {
    const accessToken = getAccessToken();

    Object.entries(config.headers).forEach(([headerName, headerValue]) => {
      config.headers.set(headerName, headerValue);
    });

    config.headers['accept-language'] ??= getLocale();

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    return config;
  });

  inst.interceptors.response.use(
    (resp) => resp,
    async (error) => {
      if (error?.response?.status === 401) {
        const accessToken = await UserServiceNS.updateToken();

        if (error?.config && accessToken) {
          return axios.request({
            ...error.config,
            headers: {
              ...error.config.headers,
              Authorization: `Bearer ${accessToken}`,
            },
          });
        }
      }

      return Promise.reject(error);
    },
  );
};

const createAgent = (configOverride?: {
  config?: CreateAxiosDefaults;
  additionalInterceprots?: ((inst: AxiosInstance) => void)[];
}) => {
  const inst = axios.create({ ...BASE_AXIOS_CONFIG, ...configOverride?.config });

  applyBaseInterceprtors(inst);

  configOverride?.additionalInterceprots?.forEach((fn) => fn(inst));
  return inst;
};

const baseAgent = createAgent();
const storageAgent = createAgent({
  config: { url: API_URL },
  additionalInterceprots: [
    (inst) => {
      inst.interceptors.request.use((config) => {
        if (!config.url) {
          return config;
        }

        const processedUrl = config.url.replace(/^\//, '');

        config.url = `${API_URL}/${processedUrl}`;

        return config;
      });
    },
  ],
});

export { storageAgent, baseAgent };
